import React from 'react';
import PropTypes from 'prop-types';
import { extend } from '@thd-nucleus/data-sources';
import { SpecialBuyCarousel } from './SpecialBuyCarousel/SpecialBuyCarousel';
import { SpecialBuyProvider } from '../context/SpecialBuyProvider';
import { useSearchProducts } from '../hooks/useSearchProducts';
import { SimpleSpecialBuyHeader } from './SpecialBuyHeader/SimpleSpecialBuyHeader';

export const SpecialBuyProducts = ({ promoType }) => {
  return (
    <SpecialBuyProvider specialBuyType={promoType} isCondensedLayout={false} simpleBanner>
      <div className="sui-paper sui-p-4 sui-pb-1 sui-mb-4">
        <SimpleSpecialBuyHeader />
        <SpecialBuyCarousel specialBuyType={promoType} />
      </div>
    </SpecialBuyProvider>
  );
};

SpecialBuyProducts.dataModel = extend({}, useSearchProducts, SpecialBuyProvider);

SpecialBuyProducts.propTypes = {
  /**
   * Identifies the type of special buy type for the products. May be one of (sbotd', 'pro')
   */
  promoType: PropTypes.string.isRequired
};

SpecialBuyProducts.displayName = 'SpecialByCarousels';
